function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';
import styled from '../../_snowpack/pkg/styled-components.js';
export const SVG = styled.svg.withConfig({
  displayName: "graph-explorer__SVG",
  componentId: "sc-1dsmnku-0"
})(["path{fill:none;stroke:", ";stroke-linecap:round;stroke-linejoin:round;stroke-width:1.2px;}"], p => p.color);
export default (({
  color = '#333',
  ...props
}) => /*#__PURE__*/React.createElement(SVG, _extends({
  viewBox: "0 0 40 40",
  color: color
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M29.8,16.64v6.8a2.29,2.29,0,0,0-2.24,2.24,2,2,0,0,0,.32,1.08l-6,3.44A2.14,2.14,0,0,0,20,29.08a2.19,2.19,0,0,0-1.92,1.12l-6-3.44a2,2,0,0,0,.32-1.08,2.14,2.14,0,0,0-1.12-1.92,2.15,2.15,0,0,0-1.12-.32v-6.8a2.24,2.24,0,0,0,2.24-2.24,2.19,2.19,0,0,0-.32-1.16l6-3.44a1.93,1.93,0,0,0,.8.8,2.12,2.12,0,0,0,2.24,0,1.56,1.56,0,0,0,.8-.8l6,3.44a2.19,2.19,0,0,0-.32,1.16A2.24,2.24,0,0,0,29.8,16.64Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.24,8.68a2.15,2.15,0,0,1-.32,1.12,1.56,1.56,0,0,1-.8.8,2.12,2.12,0,0,1-2.24,0,1.93,1.93,0,0,1-.8-.8,2.58,2.58,0,0,1-.28-1.12A2.19,2.19,0,0,1,20,6.48,2.23,2.23,0,0,1,22.24,8.68Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.8,23.44a2.29,2.29,0,0,0-2.24,2.24,2,2,0,0,0,.32,1.08,2.14,2.14,0,0,0,1.92,1.12,2.22,2.22,0,1,0,0-4.44Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.32,23.76a2.15,2.15,0,0,0-1.12-.32,2.22,2.22,0,1,0,0,4.44,2.14,2.14,0,0,0,1.92-1.12,2,2,0,0,0,.32-1.08A2.14,2.14,0,0,0,11.32,23.76Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32,14.4a2.24,2.24,0,1,1-4.48,0,2.19,2.19,0,0,1,.32-1.16,2.29,2.29,0,0,1,1.92-1.08A2.24,2.24,0,0,1,32,14.4Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.44,14.4a2.24,2.24,0,1,1-2.24-2.24,2.29,2.29,0,0,1,1.92,1.08A2.19,2.19,0,0,1,12.44,14.4Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.24,31.32A2.23,2.23,0,0,1,20,33.52a2.19,2.19,0,0,1-2.2-2.2,2.58,2.58,0,0,1,.28-1.12A2.19,2.19,0,0,1,20,29.08a2.29,2.29,0,0,1,2.24,2.24Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.68,23.76a2.14,2.14,0,0,0-1.12,1.92H12.44a2.14,2.14,0,0,0-1.12-1.92L18.88,10.6a2.12,2.12,0,0,0,2.24,0Z"
})));